module.exports = __webpack_public_path__ + "img/256x256_square_partial_warp_gate.423d6bc8.svg";